import { PositionMode } from './trade-mode';

export const PositionEvent = {
  PositionTradeSignInClick: 'your_position_trade_sign_in_click',
  PositionOrderStatusTabClick: 'your_positions_order_status_tab_click',
  PositionPnlDetailsClick: 'positions_pnl_details_click',
  PnLShareClick: 'trade_performance_share_click',
  PnLSharePageView: 'trade_performance_share_page_view',
  PnLShareCopyClick: 'trade_performance_detail_copy_link_click',
  PnLShareDownloadClick: 'trade_performance_detail_download_click',
  AdjustMarginPageView: 'adjust_margin_page_view',
  AdjustMarginPercentageClick: 'adjust_margin_percentage_click',
  AdjustMarginConfirmClick: 'adjust_margin_confirm_click',

  // adjust leverage
  AdjustLeverageBottomSheetView: 'adjust_leverage_bottom_sheet_view',
  AdjustLeverageConfirmClick: 'adjust_leverage_confirm_click',
  AdjustLeverageUpdownClick: 'adjust_leverage_updown_click',
  AdjustLeverageRangeClick: 'adjust_leverage_range_click',
  AdjustLeverageKeyboardClick: 'adjust_leverage_keyboard_click',
  AdjustLeverageCancelClick: 'adjust_leverage_cancel_click',
  AdjustLeverageXClick: 'adjust_leverage_x_click',

  YourPositionsShowAllClick: 'your_positions_show_all_click',
  YourPositionsManageClickEvent: 'your_positions_manage_click',

  CloseAllClick: 'close_all_click',
  CloseAllConfirmClick: 'close_all_confirm_click',
} as const;

export type PositionType = 'long' | 'short';
export type PageType = 'trade_page' | 'asset_page';
export type TradeType = 'perpetual' | 'spot';
export type ButtonText =
  | 'Margin'
  | 'Take profit'
  | 'Stop loss'
  | 'Leverage'
  | 'Partial close'
  | 'Full close'
  | 'Flip to long'
  | 'Flip to short'
  | 'Cancel';

export interface AdjustMarginType {
  margin_usdt: number;
  symbol: string;
  unrealized_pnl: number;
  leverage: number;
  trade_type: TradeType;
  page_type: PageType;
  position: PositionType;
}

export interface PnlClickParams {
  currency: string;
  symbol: string;
  trade_type: 'perpetual' | 'spot';
  unrealized_pnl: number | null;
  unrealized_pnl_percentage: number | null;
  realized_pnl: number | null;
  realized_pnl_percentage: number | null;
  side: 'buy' | 'sell' | null;
  profit_boost_mode?: boolean; // isBoosting (only for perpetual)
}

export interface PositionEventDataType {
  [PositionEvent.PositionTradeSignInClick]: {
    symbol: string;
  };
  [PositionEvent.PositionOrderStatusTabClick]:
    | {
        tab_type: 'Your positions';
        execution_stage: 'Open' | 'Pending';
      }
    | {
        tab_type: 'Your holdings';
        execution_stage: 'Purchased' | 'Pending';
      }
    | {
        tab_type: 'History';
        execution_stage: 'Position' | 'Order' | 'Fill';
      };
  [PositionEvent.PnLShareClick]: {
    symbol: string;
    position: 'buy' | 'sell' | null;
    leverage?: number;
    unrealized_pnl_percentage: string;
    unrealized_pnl: string;
    closing_price?: string;
    current_price?: string;
    position_status: 'open' | 'partially_closed' | 'closed';
    trade_type: 'perpetual' | 'spot';
    currency: string;
    profit_boost_mode?: boolean;
  };
  [PositionEvent.AdjustMarginPercentageClick]: AdjustMarginType & {
    percentage: number;
  };
  [PositionEvent.AdjustMarginConfirmClick]: AdjustMarginType & {
    adjust_margin_usdt: number;
  };
  [PositionEvent.AdjustLeverageConfirmClick]: {
    symbol: string;
    adjust_leverage: number;
  };
  [PositionEvent.AdjustLeverageUpdownClick]: {
    symbol: string;
    side: 'down' | 'up';
  };
  [PositionEvent.AdjustLeverageRangeClick]: {
    symbol: string;
    leverage_option: number;
  };
  [PositionEvent.AdjustLeverageKeyboardClick]: {
    symbol: string;
    adjust_leverage: number;
  };
  [PositionEvent.AdjustLeverageCancelClick]: {
    symbol: string;
    position: PositionType;
    leverage: number;
  };
  [PositionEvent.AdjustLeverageXClick]: {
    symbol: string;
    position: PositionType;
    leverage: number;
  };
  [PositionEvent.YourPositionsShowAllClick]: {
    symbol: string;
    trade_type: 'perpetual' | 'spot';
    order_status: 'Open' | 'Pending' | 'Purchased';
    is_checked: boolean;
  };
  [PositionEvent.YourPositionsManageClickEvent]: {
    button_text: ButtonText;
    symbol: string;
    side: 'buy' | 'sell';
    leverage: number;
    unrealized_pnl: number | null;
    unrealized_pnl_percentage: number | null;
    margin_usdt: number;
    position_mode: PositionMode;
    is_show_all: boolean;
    profit_boost_mode?: boolean;
    is_airdrop: boolean;
  };
  [PositionEvent.PnLShareDownloadClick]: PnlClickParams;
  [PositionEvent.PnLShareCopyClick]: PnlClickParams;
  [PositionEvent.CloseAllClick]: {
    symbol: string | null;
    num_open_positions: number;
    is_show_all: boolean | null;
    is_require_confirm: boolean;
  };
  [PositionEvent.CloseAllConfirmClick]: {
    symbol: string | null;
    num_open_positions: number;
    is_show_all: boolean | null;
    button_text: string;
  };
}
